export const Steps = [
    'Basic info',
    'Company overview 1',
    'Company overview 2',
    'Review',
    'Select Package',
];